import React from "react";
import { Routes, Route } from "react-router-dom";
import { globalRoutes } from "./globalRoutes";
import { Box } from "@mui/material";
import { Main } from "../Config/Style";

const Index = (props) => {
  const routeComponents = globalRoutes.map((item, key) => {
    const RouteElement = item.element;
    const RouteWrapper = item.routeType;

    // Check if it's a route with children (nested routes)
    return (
      <Route path={item.path} key={key} element={
        RouteWrapper ? (
          <RouteWrapper>
            <RouteElement {...props} />
          </RouteWrapper>
        ) : (
          <RouteElement {...props} />
        )
      }>
        {/* Handling child routes */}
        {item.children && item.children.map((child, childKey) => (
          <Route
            key={childKey}
            path={child.path}
            element={< child.element {...props} />}
          />
        ))}
      </Route>
    );
  });

  return (
    <Box sx={Main.mainbox}>
      <Routes>{routeComponents}</Routes>
    </Box>
  );
};

export default Index;
